import { useEffect, useMemo } from 'react';
import { useGetCurrentPosition } from '../../../../hooks/geolocation/useGetCurrentPosition';
import { useGetRegion } from '../../../../hooks/geolocation/useGetRegion';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { userRegionSlice } from '../../../../store/userRegionSlice';
import { Loading } from '../../../common/loading/Loading';

interface GetRegionModalProps {
  onSettled?: () => void;
}

export const GetRegionModal = ({ onSettled }: GetRegionModalProps) => {
  const dispatch = useAppDispatch();
  const userRegionActions = userRegionSlice.actions;

  const { latitude, longitude, isGetPositionPermissionAllowed } = useGetCurrentPosition();
  const { isGetRegionRequestSuccess, region, regionDepth1, regionDepth2, regionDepth3 } = useGetRegion({
    latitude,
    longitude,
  });

  const isGetRegionLoading = useMemo<boolean>(() => {
    if (isGetPositionPermissionAllowed === false || isGetRegionRequestSuccess !== undefined) {
      return false;
    }

    return true;
  }, [isGetPositionPermissionAllowed, isGetRegionRequestSuccess, region]);

  useEffect(() => {
    if (isGetPositionPermissionAllowed !== undefined) {
      dispatch(userRegionActions.setIsGetPositionPermissonAllowed(isGetPositionPermissionAllowed));
    }
  }, [isGetPositionPermissionAllowed]);

  useEffect(() => {
    if (isGetRegionRequestSuccess !== undefined) {
      dispatch(userRegionActions.setIsGetRegionRequestSuccess(isGetRegionRequestSuccess));
    }
  }, [isGetRegionRequestSuccess]);

  useEffect(() => {
    if (latitude !== undefined && longitude !== undefined) {
      dispatch(userRegionActions.setUserLatitude(String(latitude)));
      dispatch(userRegionActions.setUserLongitude(String(longitude)));
    }
  }, [latitude, longitude]);

  useEffect(() => {
    if (
      region !== undefined &&
      regionDepth1 !== undefined &&
      regionDepth2 !== undefined &&
      regionDepth3 !== undefined
    ) {
      dispatch(userRegionActions.setUserRegion(region));
      dispatch(userRegionActions.setUserRegionDepth1(regionDepth1));
      dispatch(userRegionActions.setUserRegionDepth2(regionDepth2));
      dispatch(userRegionActions.setUserRegionDepth3(regionDepth3));
    }
  }, [region]);

  useEffect(() => {
    if (!isGetRegionLoading) {
      if (onSettled) {
        onSettled();
      }
    }
  }, [isGetRegionLoading]);

  return <Loading loading={isGetRegionLoading} />;
};
